import { render } from "./AgentComp.vue?vue&type=template&id=dfd2b288&scoped=true"
import script from "./AgentComp.vue?vue&type=script&lang=js"
export * from "./AgentComp.vue?vue&type=script&lang=js"

import "./AgentComp.vue?vue&type=style&index=0&id=dfd2b288&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd2b288"]])

export default __exports__